/**
 * Checks that an array has at least one item, and returns a boolean representing a proof of this.
 * After calling this function, the first item of the array can be safely used without further
 * bounds-checking.
 */
export const isNonEmpty = <T>(list: readonly T[]): list is NonEmpty<T[]> => list.length >= 1;

/** Asserts that an array has at least one item. Throws an exception otherwise.
 */
export const assertNonEmpty: <T>(list: readonly T[]) => asserts list is NonEmpty<T[]> = list => {
  if (list.length < 1) throw new Error(`Array is empty`);
};

/** An array containing at least one item.
 *
 * NonEmpty<string[]> is equivalent to MinLength<string, 1>.
 */
export type NonEmpty<T> = T extends readonly (infer S)[] ? readonly [S, ...S[]] : never;
